import {Observable, of} from 'rxjs';
import {ColorSchemeService} from '../color-scheme.service';
import {ColorScheme, ColorSchemeResponse} from '../../models/color-scheme';


export const mockProjects: ColorScheme [] = [
    {
        name: 'Licht Blauw',
        primaryColor: '#5399DB',
        backgroundColor: '#EEF5FB',
    },
    {
        name: 'Donker Blauw',
        primaryColor: '#1F3C6E',
        backgroundColor: '#F0F2F6',

    },

];

export class ColorSchemeServiceMock implements ColorSchemeService {


    list(projectReferenceId: number): Observable<ColorSchemeResponse[]> {

        if (
            projectReferenceId == 1
        ) {
            return of(mockProjects.map( colorScheme => {
                return {
                    colorScheme,
                    default: colorScheme.name === 'Donker Blauw'
                }
            }))
        }

         else
         {
            return of(mockProjects.map ( colorScheme => {
                return {
                    colorScheme,
                    default: colorScheme.name === 'Licht Blauw'
                }
            }))
        }

    }

}
